import config from "src/config";
import { BomDto, BomModalDto, BomParentModalDto } from "src/dtos/bom/BomDto";
import { ResponseDto } from "src/dtos/common/responseDto";
import { ItemDto } from "src/dtos/item/itemDto";
import { getData } from "src/utils/axios/serverHelper";

const bomUrl = `${config.apiUrl}/bom`;

export const getBomChildItemList = async (prntItemcd: string) => {

	const url = `${bomUrl}/childItem`;

	return await getData<ResponseDto<BomModalDto[]>>(url, {
		params: {
			prntItemcd
		}
	})
}

export const getBomParentItemList = async (prntItemcd: string) => {

	const url = `${bomUrl}/parentItem`;

	return await getData<ResponseDto<BomParentModalDto[]>>(url, {
		params: {
			prntItemcd
		}
	})
}